import Vue from 'vue';
import Router from 'vue-router';
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';
import service from './services';
import storage from './services/storage';
import jwt from 'jsonwebtoken';
import { KEY_LOCAL_STORAGE } from './const';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/v2/Index.vue'),
        //default: () => import('./pages/EmConstrucao.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },

    {
      path: '/Login',
      name: 'login',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/Login.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },

    {
      path: '/EsqueciASenha',
      name: 'EsqueciASenha',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/EsqueciASenha.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },

    {
      path: '/comoFunciona',
      name: 'comoFunciona',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/comoFunciona.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },

    {
      path: '/redefinirSenha/:cpf',
      name: 'redefinirSenha',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/redefinirSenha.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },

    {
      path: '/logoff',
      name: 'logoff',
      beforeEnter: function(to, from, next) {
        removeClass();
        removeToken(next);
      },
      components: {
        default: () => import('./pages/v2/Index.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },
    {
      path: '/cadastro',
      name: 'cadastro',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/Cadastro.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },

    {
      path: '/saldo',
      name: 'saldo',
      beforeEnter: function(to, from, next) {
        isAuth(to, next);
      },
      components: {
        default: () => import('./pages/Saldo.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },

    {
      path: '/ajuda',
      name: 'Ajuda',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/Ajuda.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },
    {
      path: '/TermosDeUso',
      name: 'TermosDeUso',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/TermosDeUso.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },

    {
      path: '/PoliticaDePrivacidade',
      name: 'PoliticaDePrivacidade',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/PoliticaDePrivacidade.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },
    {
      path: '/thank-you',
      name: 'thankyou',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/thankyou.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },

    {
      path: '/dashboard',
      name: 'dashboard',
      beforeEnter: function(to, from, next) {
        isAuth(to, next, true);
      },
      components: {
        default: () => import('./pages/DashBoard.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      children: [
        {
          path: '/',
          name: 'dadosCadastrais',
          beforeEnter: function(to, from, next) {
            removeClass();
            isAuth(to, next, true);
          },
          component: () => import('./pages/components_site/formCadastro.vue'),
          props: {
            interno: true,
          },
        },
        {
          path: '/dadosCadastrais',
          name: 'dadosCadastrais',
          beforeEnter: function(to, from, next) {
            removeClass();
            isAuth(to, next, true);
          },
          component: () => import('./pages/components_site/formCadastro.vue'),
          props: {
            interno: true,
          },
        },
        {
          path: '/saldoInterno',
          name: 'saldoInterno',
          beforeEnter: function(to, from, next) {
            removeClass();
            isAuth(to, next, true);
          },
          component: () => import('./pages/Saldo.vue'),
          props: {
            interno: true,
          },
        },
        {
          path: '/meuEndereco',
          name: 'meuEndereco',
          beforeEnter: function(to, from, next) {
            removeClass();
            isAuth(to, next, true);
          },
          component: () => import('./pages/components_site/formEndereco.vue'),
        },
        {
          path: '/meuFinanceiro',
          name: 'meuFinanceiro',
          beforeEnter: function(to, from, next) {
            removeClass();
            isAuth(to, next, true);
          },
          component: () =>
            import('./pages/components_site/listarFinanceiro.vue'),
        },

        {
          path: '/Afiliados',
          name: 'Afiliados',
          beforeEnter: function(to, from, next) {
            removeClass();
            isAuth(to, next, true);
          },
          component: () => import('./pages/components_site/afiliados.vue'),
        },
        {
          path: '/meusItens',
          name: 'meusItens',
          beforeEnter: function(to, from, next) {
            removeClass();
            isAuth(to, next, true);
          },
          component: () => import('./pages/components_site/listarItens.vue'),
        },
        {
          path: '/MeuHistorico',
          name: 'MeuHistorico',
          beforeEnter: function(to, from, next) {
            removeClass();
            isAuth(to, next, true);
          },
          component: () =>
            import('./pages/components_site/listarHistorico.vue'),
        },
        {
          path: '/MinhasEntregas',
          name: 'MinhasEntregas',
          beforeEnter: function(to, from, next) {
            removeClass();
            isAuth(to, next, true);
          },
          component: () => import('./pages/components_site/listarEntregas.vue'),
        },
      ],
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },
    {
      path: '/:caixa',
      name: 'detalheCaixa',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/v2/Caixa.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
          isDetalheCaixa: true,
        },
      },
    },
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

function isAuth(to, next, toAdmin) {
  const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);
  if (token) {
    const decoded = jwt.decode(token);
    service
      .validaToken(token, 'Login', 'ValidateToken')
      .then(res => {
        if (res.data.result == false) {
          removeToken(next, to.name);
        } else {
          next();
        }
      })
      .catch(e => {
        console.error(e);
        removeToken(next, to.name);
      });
  } else {
    removeToken(next, to.name);
  }
}

function removeToken(next, name) {
  storage.removeItem(KEY_LOCAL_STORAGE.USER_TOKEN);
  storage.removeItem(KEY_LOCAL_STORAGE.SALDO);
  storage.removeItem(KEY_LOCAL_STORAGE.QUANT_ITENS);
  storage.removeItem(KEY_LOCAL_STORAGE.VALORCREDITO);
  //storage.clear();
  if (name) next(`/Login?redirect=${name}`);
  else next(`/Login`);
}

function removeClass() {
  let htmlClasses = document.querySelector('html').classList;
  htmlClasses.remove('nav-open');
  //redirect to index
  //location.href = '/';
}
